import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Gallery2 from '../components/gallery2/Gallery2';
import Slider2 from '../components/slider/Slider2';

const pathsChunks: Array<Array<HTMLElement>> = [];

@Component({
  components: {
    Slider2,
    Gallery2
  }
})
export default class VMArticle extends Vue {

}
